module.exports = __webpack_public_path__ + "img/61.9c8defbb.jpg";